import { UATCalculation, CalculationType } from './types';
import { UATCalculationDisplay } from './uat-nri-calculation';
import { UATFormula } from './uat-nri-formula';
import styles from './uat-nri-calculation-popup.module.scss';

const getTitle = (calculationType: CalculationType) => {
  return calculationType === 'NRI'
    ? 'UAT NRI Calculation'
    : 'UAT WI Calculation';
};

export const UATCalculationPopup = ({
  tractValue,
  uat,
  uatUnit,
  length,
  lengthUnit,
  participationTract,
  participationTractUnit,
  uatValueAc,
  uatValueAcUnit,
  result,
  calculationType,
  hasAllocationManager = false,
  tractNriFormula,
  tractNriCalculationMethod,
  instrumentType,
}: UATCalculation) => {
  return (
    <div>
      <div className={styles.title}>{getTitle(calculationType)}</div>
      <UATCalculationDisplay
        tractValue={tractValue}
        uat={uat}
        uatUnit={uatUnit}
        length={length}
        lengthUnit={lengthUnit}
        participationTract={participationTract}
        participationTractUnit={participationTractUnit}
        uatValueAc={uatValueAc}
        uatValueAcUnit={uatValueAcUnit}
        result={result}
        calculationType={calculationType}
      />
      <UATFormula
        calculationType={calculationType}
        hasAllocationManager={hasAllocationManager}
        tractNri={tractValue}
        tractNriFormula={tractNriFormula}
        tractNriCalculationMethod={tractNriCalculationMethod}
        instrumentType={instrumentType}
      />
    </div>
  );
};

// Keep for backwards compatibility
export const UATNRICalculationPopup = UATCalculationPopup;
